import React from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import findIndex from 'lodash/findIndex';
import flow from 'lodash/flow';
import find from 'lodash/find';
import { shouldHideOption } from '@gcc/configurator';
import ChoiceBoxSection from '@gcc/pip-components/dist/ChoiceBoxSection';
import ChoiceBoxSelect from '@gcc/pip-components/dist/ChoiceBoxSelect';
import withIsMobile from '@gcc/pip-components/dist/withIsMobile';
import WarningMessage from '@gcc/pip-components/dist/WarningMessage';
import Carousel from '@gcc/pip-components/dist/Carousel';
import { Context as CollapseContext } from '@gcc/pip-components/dist/collapsibles';
import ConfiguratorTemplate from '../ConfiguratorTemplate';
import FlooringCard from '../../components/accordion';
import { extractBoldText, noBoldText } from '../../utils/extractText';
import { boldStart } from '../../utils/boldCovention';
import { ChoiceWrapper, Description, FixedSizeChoiceImageWrapper } from './styles';

class FlooringOptionSingleSelectTemplate extends React.Component {
  getDefinition = () => this.props.attributes[camelCase(this.props.option.shortLabel)];

  getSelectedChoice() {
    const { choices } = this.props;
    return find(choices, 'isSelected');
  }

  getHrefForChoice = (choiceId) => {
    const { configLinks } = this.props;
    return configLinks[choiceId];
  };

  optionChange = (choice) => {
    const { id, shortLabel: choiceValue } = choice;
    this.props
      .onChoiceSelected(this.props.option.id, id, choiceValue)
      .then(() => this.props.onChoiceSelectedSuccess());
  };

  render() {
    console.log("PROPS", this.props);
    const properties = this.props;
    const shouldHide = shouldHideOption(properties.option, properties.options, properties.productChoices);
    return !shouldHide &&
      (
        <CollapseContext.Provider fullCount={properties.choices.length}>
          <FlooringCard title={properties.option.shortLabel} testId="single-selection-section">
            <Description>{properties.option.longLabel.includes(boldStart) ? (
              <>
                <p>{noBoldText(properties.option.longLabel)}
                  <b>{extractBoldText(properties.option.longLabel)}</b>
                </p>
              </>) : (<p>{properties.option.longLabel}</p>)}
            </Description>
            <FixedSizeChoiceImageWrapper>
              <ChoiceBoxSection nullable>
                <CollapseContext.Consumer>
                  {() => {
                    const { choices } = properties;
                    const selectedChoiceIndex = findIndex(choices, 'isSelected') || 0;
                    const { isRequired, isIndexable } = properties.option;
                    const select = (
                      <ChoiceWrapper>
                        <ChoiceBoxSelect
                          options={choices}
                          value={choices[selectedChoiceIndex]}
                          keyBy={choice => choice.id}
                          labelBy={choice => choice.shortLabel}
                          imageBy={choice => choice.mediaUrl}
                          onChange={this.optionChange}
                          hrefBy={choice => this.getHrefForChoice(choice.id)}
                          indexable={isIndexable && isRequired}
                          displayCheckbox
                          OptionEstimator
                        />
                      </ChoiceWrapper>
                    );

                    return properties.isMobile ? <Carousel>{select}</Carousel> : select;
                  }}
                </CollapseContext.Consumer>
              </ChoiceBoxSection>
            </FixedSizeChoiceImageWrapper>
            <WarningMessage option={properties.option} />
          </FlooringCard>
        </CollapseContext.Provider>
      );
  }
}

FlooringOptionSingleSelectTemplate.propTypes = {
  choices: PropTypes.array.isRequired,
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    shortLabel: PropTypes.string.isRequired,
    messages: PropTypes.array,
    isRequired: PropTypes.bool.isRequired,
    isIndexable: PropTypes.bool.isRequired,
    longLabel: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.array.isRequired,
  productChoices: PropTypes.array.isRequired,
  attributes: PropTypes.object.isRequired,
  onChoiceSelected: PropTypes.func.isRequired,
  onChoiceSelectedSuccess: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  configLinks: PropTypes.object.isRequired,
};

export default flow(
  withIsMobile,
  ConfiguratorTemplate,
)(FlooringOptionSingleSelectTemplate);
